export const MARKETING_CARD_IMAGE_ADDRESS =
  "b3bbe7e6-f68e-45e3-8124-691e18a4a3ca";
export const MARKETING_BANNER_IMAGE_ADDRESS =
  "fb06f1b7-87ff-4fcf-8a98-51a7fb4ba36d";
